<template>
  <div class='unresolved-tag'>
    {{ $t('unresolved') }}
  </div>
</template>

<script>
export default {
  name: 'UnresolvedTag',
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.unresolved-tag {
  display: inline-block;
  background-color: rgba(169, 182, 195, 0.1);
  color: var(--text-muted);
  text-align: center;
  font-family: $font-family-semibold;
  font-size: $font-size-sm;
  padding: rem(1) rem(5);
  border-radius: $radius-md;
}
</style>
